<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000168')"
					:inputValue="commCdType"
					:options="commCdTypeOptions"
					:onChange="value => onChangeSearchParam({ key: 'commCdType', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('SWCC000169')"
					:inputValue="commCdTypeName"
					:onChange="value => onChangeSearchParam_({ key: 'commCdTypeName', value })"
				/>
			</el-col>
			<!-- <el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000145')"
					:inputValue="useYn"
					:options="useYnOptions"
					:onChange="value => onChangeSearchParam({ key: 'useYn', value })"
				/>
			</el-col> -->
		</el-row>
		<template slot="button">
			<sf-button line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="search">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>

<script>
import { serviceMethods, serviceComputed } from '../../store/helpers';
import { rootComputed } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.$sf_toggleLoading(true);
		this.getCommCodes_({ key: 'optionLangs', codeType: 'LANG' }).catch(error => {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			Promise.reject(error);
		});
		Promise.all([this.searchCommCd_({ commCdType: 'USE_YN', init: [] }), this.searchCommCdTypeOptions_()])
			.then(([header]) => {
				if (header.code !== 0) {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				}
			})
			.catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			})
			.finally(() => this.$sf_toggleLoading(false));
	},
	methods: {
		...serviceMethods,
		onChangeSearchParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeSearchParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		search() {
			this.$sf_toggleLoading(true);
			this.searchCommCdType_({ ...this.commCdTypePagingInfo, currentPage: 1 }).finally(() => this.$sf_toggleLoading(false));
		}
	},
	computed: {
		...serviceComputed,
		...rootComputed,
		commCdType: {
			get() {
				return this.searchParam.commCdType;
			},
			set(v) {
				this.searchParam.commCdType = v;
			}
		},
		commCdTypeName: {
			get() {
				return this.searchParam.commCdTypeName;
			},
			set(v) {
				this.searchParam.commCdTypeName = v;
			}
		},
		useYn: {
			get() {
				return this.searchParam.useYn;
			},
			set(v) {
				this.searchParam.useYn = v;
			}
		}
	}
};
</script>
